import moment from "moment";
import React, { Component, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import AddPricingEquipmentTemplate from "../../../modals/add-pricing-equipment-template/add-pricing-equipment-template";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./pricing-equipment-template.scss";
import {
    DeletePricingEquipmentTemplate,
    UserData,
    GetUserDetailsById,
} from "../../../../api";
import Loader from "../../../loader/loader";
import config from "../../../../config";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import { getAlertPopUp } from "../../../helper/helper";

const STRATUS_URL = config.paymentcloud.STRATUS_URL;

const filterType = "pricingAndEquipment";
class PricingEquipmentTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddTeamplateModel: false,
            searchValue: "",
            selectedTemplate: {},
            showSpinner: true,
            user: null,
            copyTitle: "Copy to clipboard",
        };
    }
    componentDidMount() {
        UserData().then((response) => {
            this.setState({ user: response });
        });
        this.props.handleSearchKeyChange(this.state.searchValue, filterType);
    }

    handleShowModel = () => {
        this.props.handleSearchKeyChange(this.state.searchValue, "pricing");
        this.props.handleSearchKeyChange(this.state.searchValue, "equipment");
        this.setState({ selectedTemplate: undefined }, () => {
            this.setState({ showAddTeamplateModel: true });
        });
    };

    handleKeyWordChange = (evt) => {
        this.setState({ searchValue: evt.target.value }, () => {
            this.props.handleSearchKeyChange(
                this.state.searchValue,
                filterType,
            );
        });
    };

    handleSearchClick = (evt) => {
        if (this.state.searchValue !== "")
            this.props.handleSearchKeyChange(
                this.state.searchValue,
                filterType,
            );
    };

    editTemplate(template) {
        const templateOptions = template;
        this.setState({ selectedTemplate: templateOptions }, () => {
            this.setState({ showAddTeamplateModel: true });
        });
    }

    handleTemplateDelete = (evt) => {
        confirmAlert({
            title: "Delete Template",
            message: "Are you sure you want to delete the template?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.deleteTemplate(evt),
                },
                {
                    label: "No",
                },
            ],
        });
    };
    deleteTemplate(template) {
        DeletePricingEquipmentTemplate(template.id)
            .then((response) => {
                if (response.success) {
                    this.props.handleSearchKeyChange(
                        this.state.searchValue,
                        filterType,
                    );
                    const popup = {
                        title: "Success!",
                        html: "Record removed successfully",
                    };
                    getAlertPopUp(popup);
                } else {
                    const popup = {
                        title: "Error!",
                        html: response.message,
                        error: true,
                    };
                    getAlertPopUp(popup);
                }
            })
            .catch((error) => console.log(error));
    }

    copyWidgetLink(template) {
        let templateID = template.id;
        let magicalLink = "";
        if (this.props.selected_user_id) {
            GetUserDetailsById(this.props.selected_user_id)
                .then((response) => {
                    if (response.success) {
                        let agentUrl = response.data.agent_url;
                        let orgSlug =
                            response.data.organization.whitelabel_slug;
                        magicalLink = `<script src="${config.paymentcloud.STRATUS_URL}widget/index.js" org-slug="${orgSlug}" agent-url="${agentUrl}" template-id="${templateID}" div-id="your div ID"></script>`;
                        navigator.clipboard.writeText(magicalLink);
                        this.setState({ copyTitle: "Copied!" });
                    } else {
                        const popup = {
                            title: "Error!",
                            html: response.message,
                            error: true,
                        };
                        getAlertPopUp(popup);
                    }
                })
                .catch((error) => {
                    const popup = {
                        title: "Error!",
                        html: "Sorry! something wrong please try again.",
                        error: true,
                    };
                    getAlertPopUp(popup);
                });
        } else {
            let agentUrl = this.state.user.agent_url;
            let orgSlug = this.state.user.organization.whitelabel_slug;
            magicalLink = `<script src="${config.paymentcloud.STRATUS_URL}widget/index.js" org-slug="${orgSlug}" agent-url="${agentUrl}" template-id="${templateID}" div-id="your div ID"></script>`;
            navigator.clipboard.writeText(magicalLink);
            this.setState({ copyTitle: "Copied!" });
        }
    }
    copyMagicalLink(template) {
        let templateID = template.id;
        let ems_office = template.ems_office;
        let magicalLink = "";
        if (this.props.selected_user_id) {
            GetUserDetailsById(this.props.selected_user_id)
                .then((response) => {
                    if (response.success) {
                        let agentUrl = response.data.agent_url;
                        let orgSlug =
                            response.data.organization.whitelabel_slug;
                        if (ems_office) {
                            magicalLink =
                                STRATUS_URL +
                                "create-blank-app/" +
                                orgSlug +
                                "/" +
                                agentUrl +
                                "/" +
                                templateID +
                                "/" +
                                ems_office;
                        } else {
                            magicalLink =
                                STRATUS_URL +
                                "create-blank-app/" +
                                orgSlug +
                                "/" +
                                agentUrl +
                                "/" +
                                templateID;
                        }

                        navigator.clipboard.writeText(magicalLink);
                        this.setState({ copyTitle: "Copied!" });
                    } else {
                        const popup = {
                            title: "Error!",
                            html: response.message,
                            error: true,
                        };
                        getAlertPopUp(popup);
                    }
                })
                .catch((error) => {
                    const popup = {
                        title: "Error!",
                        html: "Sorry! something wrong please try again.",
                        error: true,
                    };
                    getAlertPopUp(popup);
                });
        } else {
            let agentUrl = this.state.user.agent_url;
            let orgSlug = this.state.user.organization.whitelabel_slug;
            if (ems_office) {
                magicalLink =
                    STRATUS_URL +
                    "create-blank-app/" +
                    orgSlug +
                    "/" +
                    agentUrl +
                    "/" +
                    templateID +
                    "/" +
                    ems_office;
            } else {
                magicalLink =
                    STRATUS_URL +
                    "create-blank-app/" +
                    orgSlug +
                    "/" +
                    agentUrl +
                    "/" +
                    templateID;
            }

            navigator.clipboard.writeText(magicalLink);
            this.setState({ copyTitle: "Copied!" });
        }
    }
    resetTitle() {
        this.setState({ copyTitle: "Copy to clipboard" });
    }

    render() {
        const { showAddTeamplateModel, searchValue } = this.state;
        const {
            isPcAdmin,
            userData,
            selected_org_id,
            selected_user_id,
            templateList,
        } = this.props;
        return (
            <>
                {showAddTeamplateModel === true &&
                    this.props.showSpinner != true && (
                        <AddPricingEquipmentTemplate
                            showAddTeamplateModel={showAddTeamplateModel}
                            handleCloseModel={() =>
                                this.setState({ showAddTeamplateModel: false })
                            }
                            show={showAddTeamplateModel}
                            organization_id={selected_org_id}
                            GetTemplateList={() =>
                                this.props.handleSearchKeyChange(
                                    this.state.searchValue,
                                    filterType,
                                )
                            }
                            selectedTemplate={this.state.selectedTemplate}
                            show_null_users={this.props.show_null_users}
                            save_as_system={this.props.save_as_system}
                            selected_user_id={selected_user_id}
                            equipmentTemplateList={
                                this.props.equipmentTemplateList
                            }
                            pricingTemplateList={this.props.pricingTemplateList}
                            user={this.state.user}
                        />
                    )}
                <div className="panel-heading" id="pannel-headingId">
                    <div className="header-search">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <input
                                value={searchValue}
                                type="text"
                                placeholder="Search Template"
                                name="search"
                                className="search-box"
                                onChange={(evt) =>
                                    this.handleKeyWordChange(evt)
                                }
                            />
                            <button
                                onClick={(e) => this.handleSearchClick(e)}
                                type="button"
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </form>
                        <div className="templete-dropdown-filter">
                            {isPcAdmin === true && (
                                <div className="org-dropdown">
                                    <SelectDropDown
                                        isSearchable={true}
                                        options={
                                            this.props.org_options
                                                ? this.props.org_options
                                                : []
                                        }
                                        name="filter_by_organization"
                                        placeholder="Search by organization"
                                        value={selected_org_id}
                                        handleChange={(selected) => {
                                            if (selected != null) {
                                                this.props.handleOrgChange(
                                                    selected.value,
                                                    filterType,
                                                );
                                            }
                                        }}
                                        clearValue={true}
                                        templateReset={() =>
                                            this.props.resetOrgValue(filterType)
                                        }
                                    />
                                </div>
                            )}
                            <div className="user-dropdown">
                                {(isPcAdmin === true ||
                                    userData.role == "admin") &&
                                    selected_org_id && (
                                        <SelectDropDown
                                            isSearchable={true}
                                            options={this.props.user_options}
                                            name="filter_by_user"
                                            placeholder="Search by user"
                                            value={selected_user_id}
                                            handleChange={(selected) => {
                                                if (selected != null) {
                                                    this.props.handleUserChange(
                                                        selected.value,
                                                        filterType,
                                                    );
                                                }
                                            }}
                                            clearValue={true}
                                            templateReset={() =>
                                                this.props.resetUserValue(
                                                    filterType,
                                                )
                                            }
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <button
                            className="orgbtn"
                            onClick={() => this.handleShowModel()}
                        >
                            <i className="fa fa-create"></i> Add Template
                        </button>
                    </div>
                </div>

                <div className="table-organizations table-templates">
                    {templateList && templateList.length > 0 ? (
                        <table
                            className="table table-striped table-responsive template-list"
                            id="template-index-table"
                        >
                            <thead>
                                <tr>
                                    <th className="TemplateTitle">
                                        Template ID
                                    </th>
                                    <th className="TemplateTitle">
                                        Template Name
                                    </th>
                                    <th className="TemplateTitle">
                                        Magical Link
                                    </th>
                                    <th className="TemplateTitle">
                                        Widget Link
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {templateList.map((template, index) => (
                                    <tr key={"tr" + index}>
                                        <td className="temp-id-column">
                                            <div className="org-full-name">
                                                <h4>{template.id}</h4>
                                            </div>
                                        </td>
                                        <td className="temp-name">
                                            <div className="org-full-name">
                                                <h4>
                                                    {template.template_name}
                                                </h4>
                                            </div>
                                        </td>
                                        <td className="click-to-copy">
                                            <div className="org-full-name">
                                                <h4
                                                    onClick={(evt) => {
                                                        this.copyMagicalLink(
                                                            template,
                                                        );
                                                    }}
                                                    onMouseOut={(evt) => {
                                                        this.resetTitle();
                                                    }}
                                                >
                                                    Click To Copy
                                                    <span>
                                                        {this.state.copyTitle}
                                                    </span>
                                                </h4>
                                            </div>
                                        </td>
                                        <td className="click-to-copy">
                                            <div className="org-full-name">
                                                <h4
                                                    onClick={(evt) => {
                                                        this.copyWidgetLink(
                                                            template,
                                                        );
                                                    }}
                                                    onMouseOut={(evt) => {
                                                        this.resetTitle();
                                                    }}
                                                >
                                                    Click To Copy
                                                    <span>
                                                        {this.state.copyTitle}
                                                    </span>
                                                </h4>
                                            </div>
                                        </td>
                                        <td className="addresidual template-add-delete">
                                            <span
                                                onClick={(evt) => {
                                                    this.editTemplate(template);
                                                }}
                                            >
                                                Edit
                                            </span>

                                            {isPcAdmin === true ||
                                            userData.role == "admin" ||
                                            userData.id ==
                                                template.created_by ? (
                                                <span
                                                    onClick={(evt) =>
                                                        this.handleTemplateDelete(
                                                            template,
                                                        )
                                                    }
                                                    className="addresidualIMG"
                                                >
                                                    <img src="/images/delet.svg " />
                                                </span>
                                            ) : (
                                                <span className="addresidualIMG cursor-not-allowed">
                                                    <img src="/images/delet.svg " />
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : !this.props.showSpinner ? (
                        <p className="no-data text-center">
                            {" "}
                            No Templates found
                        </p>
                    ) : (
                        ""
                    )}
                </div>
                {this.props.showSpinner ? (
                    <div className="pricing-equipment-loader">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default PricingEquipmentTemplate;
